import { Box } from '@mui/material';
import DataCard from 'components/data-card/data-card.component';
import { useSMSTotalsSearch } from 'pages/analytics/sms-reports/sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import { useTranslation } from 'react-i18next';

const PasswordlessAuthenticationSummaryHeader = () => {
  const { t } = useTranslation();

  const { data, isFetching } = useSMSTotalsSearch('PASSWORDLESS_AUTH');

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)' }}
      gap={2}
    >
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.passwordlessAuthentication.summaryHeader.passwordlessAuthenticationSMSTotal.title',
        )}
        value={data?.smsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.passwordlessAuthentication.summaryHeader.passwordlessAuthenticationSMSTotal.description',
        )}
        loading={isFetching}
        data-testid="PasswordlessAuthenticationSMSTotal.Card"
      />
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.passwordlessAuthentication.summaryHeader.passwordlessAuthenticationSMSSegmentTotal.title',
        )}
        value={data?.segmentsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.passwordlessAuthentication.summaryHeader.passwordlessAuthenticationSMSSegmentTotal.description',
        )}
        loading={isFetching}
        data-testid="PasswordlessAuthenticationSMSSegmentTotal.Card"
      />
    </Box>
  );
};

export default PasswordlessAuthenticationSummaryHeader;
